import React, { useEffect, useState } from 'react';
import Paper from '@mui/material/Paper';
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';

import { axiosInstance } from 'api/Api';

const LastNews = ({ news }) => {
  const [loading, setLoading] = useState(false);
  const [blog, setBlog] = useState([]);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  useEffect(() => {
    setLoading(true);
    axiosInstance()
      .get('/get-latest-blog')
      .then((r) => {
        setBlog(r.data.blog);
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  return (
    <Paper elevation={1} className={'normal-shadow rounded-lg'}>
      <div className="bg-white mt-5 card card-flush">
        <div className="card-header pt-5">
          <h3 className="card-title align-items-start flex-column">
            <span className="card-label fw-bolder text-dark">آخرین اخبار</span>
          </h3>
          <div
            className="card-toolbar"
            data-bs-toggle="tooltip"
            data-bs-placement="top"
            data-bs-trigger="hover"
            title=""
            data-bs-original-title="مشاهده همه"
          >
            <a
              href="https://zaminhost.com/blog"
              className="btn btn-sm btn-primary btn-light btn-active-primary"
              data-bs-toggle="modal"
              data-bs-target="#kt_modal_invite_friends"
            >
              <span className={'f-09'}>مشاهده همه</span>
            </a>
          </div>
        </div>
        <div className="card-body pt-5">
          {loading ? (
            <div className="text-center mx-auto">
              <Box
                sx={{ display: 'flex', marginLeft: '15px' }}
                className={'mt-5 mx-auto'}
                style={{ 'textAlign': 'center', display: 'block' }}
              >
                <CircularProgress />
              </Box>
            </div>
          ) : (
            <>
              {blog &&
                blog.map((item, index) => (
                  <div key={index}>
                    <div className="d-flex align-items-start flex-stack mt-2 justify-content-start">
                      <button
                        type="button"
                        className="btn btn-icon btn-sm h-auto btn-color-primary btn-active-color-primary justify-content-end"
                      >
                        <span className="svg-icon svg-icon-2 pe-4">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="20"
                            height="20"
                            viewBox="0 0 24 24"
                            fill="none"
                          >
                            <path
                              opacity="0.3"
                              d="M4.7 17.3V7.7C4.7 6.59543 5.59543 5.7 6.7 5.7H9.8C10.2694 5.7 10.65 5.31944 10.65 4.85C10.65 4.38056 10.2694 4 9.8 4H5C3.89543 4 3 4.89543 3 6V19C3 20.1046 3.89543 21 5 21H18C19.1046 21 20 20.1046 20 19V14.2C20 13.7306 19.6194 13.35 19.15 13.35C18.6806 13.35 18.3 13.7306 18.3 14.2V17.3C18.3 18.4046 17.4046 19.3 16.3 19.3H6.7C5.59543 19.3 4.7 18.4046 4.7 17.3Z"
                              fill="black"
                            />
                            <rect
                              x="21.9497"
                              y="3.46448"
                              width="13"
                              height="2"
                              rx="1"
                              transform="rotate(135 21.9497 3.46448)"
                              fill="black"
                            />
                            <path
                              d="M19.8284 4.97161L19.8284 9.93937C19.8284 10.5252 20.3033 11 20.8891 11C21.4749 11 21.9497 10.5252 21.9497 9.93937L21.9497 3.05029C21.9497 2.498 21.502 2.05028 20.9497 2.05028L14.0607 2.05027C13.4749 2.05027 13 2.52514 13 3.11094C13 3.69673 13.4749 4.17161 14.0607 4.17161L19.0284 4.17161C19.4702 4.17161 19.8284 4.52978 19.8284 4.97161Z"
                              fill="black"
                            />
                          </svg>
                        </span>
                      </button>
                      <a
                        href={item.link}
                        className="opacity-75-hover fs-7"
                        target={'_blank'}
                        style={{ textAlign: 'right' }}
                      >
                        {item.title}
                      </a>
                    </div>
                    {index !== item.length - 1 && (
                      <div className="separator separator-dashed my-3" />
                    )}
                  </div>
                ))}
            </>
          )}
        </div>
      </div>
    </Paper>
  );
};

export default LastNews;
